/* eslint-disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".ImageExample .ms-Image{border:2px solid "},{"theme":"neutralSecondary","defaultValue":"#605e5c"},{"rawString":";margin-bottom:20px}"}]);